<script lang="ts" setup>
import { computed } from 'vue'

import { getParticipantTeamSide } from '@collector/shared-ui-domain'
import { Participant } from '@collector/sportsapi-client-legacy'

interface Props {
  participant: Participant
}

const props = defineProps<Props>()

// computed
const teamSide = computed(() => getParticipantTeamSide(props.participant))
</script>

<template>
  <div
    :class="{
      'bg-current-team-home-10': teamSide === 'home',
      'bg-current-team-away-10': teamSide === 'away',
    }"
  >
    <slot />
  </div>
</template>
